





























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';
import AppLinkedinFollowPlugin from '@/components/AppLinkedinFollowPlugin.vue';

@Component({
    name: 'AppSiteNav',
    components: { AppLinkedinFollowPlugin },
})
export default class AppSiteNav extends Vue {
    @Action('search/searchForResults') protected searchForResults!: ({
        keywords,
    }: {
        keywords: string;
    }) => void;
    @Action('user/logoutUser') protected logoutUser!: () => void;
    @Action('user/setActiveProductGroup') protected setActiveProductGroup!: (
        productGroup: ProductGroupTypes,
    ) => void;
    @Action('user/setActiveProductGroupForShoppingList') protected setActiveProductGroupForShoppingList!: (
        productGroup: ProductGroupTypes,
    ) => void;
    @Action('user/setActiveProductGroupForShoppingCart') protected setActiveProductGroupForShoppingCart!: (
        productGroup: ProductGroupTypes,
    ) => void;
    @Action('user/getShoppingListRecords')
    protected getShoppingListRecords!: () => void;
    @Action('user/getShoppingCartRecords')
    protected getShoppingCartRecords!: () => void;
    @Action('search/getProductCodeSystemList')
    protected getProductCodeSystemList!: () => void;
    @Action('projects/getProjectOverview')
    protected getProjectOverview!: () => void;
    @Action('search/getSavedSearches')
    protected getSavedSearches!: () => Promise<unknown>;
    @Action('search/setProductCodeSystemList')
    protected setProductCodeSystemList!: () => void;

    protected get shoppingListCount() {
        return this.$store.getters['user/shoppingListRecords']
            ? this.$store.getters['user/shoppingListRecords'][0] && this.$store.getters['user/shoppingListRecords'][0].hasOwnProperty('value')
                ? this.$store.getters['user/shoppingListRecords'][0].value
                : this.$store.getters['user/shoppingListRecords'].length
            : null;
    }

    protected get shoppingCartCount() {
        return this.$store.getters['user/shoppingCartRecords']
            ? this.$store.getters['user/shoppingCartRecords'][0] && this.$store.getters['user/shoppingCartRecords'][0].hasOwnProperty('value')
                ? this.$store.getters['user/shoppingCartRecords'][0].value
                : this.$store.getters['user/shoppingCartRecords'].length
            : null;
    }

    protected get userData() {
        return this.$store.getters['user/userData'];
    }

    protected get isSearch() {
        return this.$route.name === 'Search';
    }

    protected get isWelcome() {
        return this.$route.name === 'Welcome';
    }

    protected get isNoGroupTypeSelected() {
        const type = this.$store.getters['user/activeProductGroup'];
        return type === ProductGroupTypes.None;
    }

    protected get searchKeywords() {
        return this.$store.getters['search/searchKeywords'];
    }

    protected get isUserAuthorized() {
        return this.$store.getters['user/isUserAuthorized'];
    }

    protected get activeProductGroup() {
        const type = this.$store.getters['user/activeProductGroup'];
        let message = '';
        if (type === ProductGroupTypes.Goodwill) {
            message = 'Goodwill';
        }
        if (type === ProductGroupTypes.Trademark) {
            message = 'Trademark';
        }
        if (type === ProductGroupTypes.CustomerRelations) {
            message = 'Customer relations';
        }
        if (type === ProductGroupTypes.Technology) {
            message = 'Technology';
        }
        if (type === ProductGroupTypes.Software) {
            message = 'Software';
        }
        return message;
    }

    protected get productGroupTypes() {
        return ProductGroupTypes;
    }

    protected get userImage() {
        if (!this.userData) {
            return {
                avatar: false,
                initials: false,
                color: this.$store.getters['user/userColor'],
            };
        }
        if (this.userData.profilePicture) {
            return {
                avatar: this.userData.profilePicture.largeSizeUrl,
                initials: false,
                color: false,
            };
        }
        if (this.userData.firstName && this.userData.lastName) {
            return {
                avatar: false,
                initials:
                    this.userData.firstName.slice(0, 1).toUpperCase() +
                    this.userData.lastName.slice(0, 1).toUpperCase(),
                color: false,
            };
        }
        return {
            avatar: false,
            initials: false,
            color: this.$store.getters['user/userColor'],
        };
    }

    protected disabledNavigation = false;

    protected logout() {
        this.logoutUser();
    }

    protected showError(error: string) {
        this.$message.error(error);
    }

    protected async toggleActiveProductGroup(productGroup: ProductGroupTypes) {
        if (this.disabledNavigation) {
            return;
        }
        eventBus.$emit(eventBusEvents.activateGlobalLoading);

        const isSearchResults = this.$route.name === 'SearchResults';
        const isShoppingList = this.$route.name === 'ShoppingList';
        const isShoppingCart = this.$route.name === 'ShoppingCart';
        const isHelp = this.$route.name === 'Help';

        await this.setActiveProductGroup(productGroup);

        if (isShoppingList) {
          await this.setActiveProductGroupForShoppingList(productGroup);
        } else if (isShoppingCart) {
          await this.setActiveProductGroupForShoppingCart(productGroup);
        }

        if (this.isSearch || isSearchResults) {
          await this.getProductCodeSystemList();
          await this.getSavedSearches();
        }

        if (this.isSearch || isHelp) {
          await this.getProjectOverview();
        } else if (isSearchResults) {
          await this.searchForResults({
            keywords: this.$store.getters['search/searchKeywords'],
          });
        }

        if (
            this.$route.name === 'StatisticalAnalysis' ||
            this.$route.name === 'SingleRecordDetails' ||
            this.$route.name === 'SingleFolder'
        ) {
            this.$router.push({ name: 'MyProjects' }, () => {
                eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            });
            return;
        }

        eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
    }

    protected async onNavigateTo(name: string) {
        if (name === 'MyProjects' || name === 'Welcome') {
            await this.setActiveProductGroup(this.productGroupTypes.None);
            this.$router.push({ name });
        }
    }

    protected mounted() {
        eventBus.$on(eventBusEvents.disableNavigation, () => {
            this.disabledNavigation = true;
        });
        eventBus.$on(eventBusEvents.enableNavigation, () => {
            this.disabledNavigation = false;
        });
    }

    protected destroyed() {
        eventBus.$off(eventBusEvents.disableNavigation);
        eventBus.$off(eventBusEvents.enableNavigation);
    }
}
